import { useState } from "react";
import * as jstat from 'jstat';

const  App = () => {
  const [ isCantimeters, setIsCantimeters ] = useState(false);
  const [ isLength,      setIsLength ]      = useState(0);
  const [ isGirth,       setIsGirth ]       = useState(0);
  const [ isOverall,     setIsOverall ]     = useState(0);

  const inchToCM                 = 2.54; // 1 inch = 2.54 cm
  const mlToFlOzConversionFactor = 0.033814; // 1 ml ≈ 0.033814 fl oz

  const handleCantimetersChange = (event) => {
    setIsCantimeters(event.target.value === 'true');
  }

  const handleLengthChange = (event) => {
    const lengthValue = event.target.value;
    setIsLength(lengthValue);
  }

  const handleGirthChange = (event) => {
    const girthValue = event.target.value;
    setIsGirth(girthValue);
  }

  const calculateNormalDistribution = (x, mean, stdDev, cumulative) => {
    if (cumulative) {
      return jstat.normal.cdf(x, mean, stdDev);
    } else {
      return jstat.normal.pdf(x, mean, stdDev);
    }
  };

  const calculateStandardNormalDistribution = (x, cumulative) => {
    if (cumulative) {
      return jstat.normal.cdf(x, 0, 1);
    } else {
      return jstat.normal.pdf(x, 0, 1);
    }
  };
  

  const pi = () => {
    return Math.PI;
  }

  const lengthConversionFactor = isCantimeters ? 1 : inchToCM;
  const girthConversionFactor  = isCantimeters ? 1 : inchToCM;
  const lengthInCm             = isCantimeters ? isLength : isLength * inchToCM;
  const girthInCm              = isCantimeters ? isGirth : isGirth * inchToCM;

  // ***** LENGTH calculation: *******
  const weighted   = 13.94099334;
  const weightedSD = 1.710590361;
  const zScore     = ((isLength * lengthConversionFactor) - weighted) / weightedSD;
  const percentLength = calculateNormalDistribution(isLength * lengthConversionFactor, weighted, weightedSD, zScore);
  const numberLarger  = (1 - percentLength) * 1000;

  // Result values
  const percentResult = percentLength * 100;
  const numberOfMen   = Math.floor(numberLarger);
  // ***** END Length calculation: *******


  // ***** GIRTH calculation: *******

  const weightedGirth   = 11.70472984;
  const weightedSDGirth = 1.243145057;
  const zScoreGirth     = ((isGirth * girthConversionFactor) - weightedGirth) / weightedSDGirth;
  const percentGirth    = calculateNormalDistribution(isGirth * girthConversionFactor, weightedGirth, weightedSDGirth, zScoreGirth);
  const numberLargerG  = (1 - percentGirth) * 1000;

  // Result values
  const percentResultGirth = percentGirth * 100;
  const numberOfMenGirth   = Math.floor(numberLargerG);
  // ***** END GIRTH calculation: *******


   // ***** VOLUME calculation: *******

   const volumeInML   = 0.9 * lengthInCm * pi() * Math.pow((girthInCm / (2 * pi())), 2);
   const volumeInFlOz = volumeInML * mlToFlOzConversionFactor;

   const zScoreVolume = (zScore + zScoreGirth) / 2;

   const lengthFactor  = lengthInCm / weighted;
   const girthFactor   = Math.pow((girthInCm / (2 * pi())), 2) / Math.pow((weightedGirth / (2 * pi())), 2);
   const factorX       = lengthFactor * girthFactor;

   const percentVolume = calculateStandardNormalDistribution(zScoreVolume, true);
   const numberLargerV  = (1 - percentVolume) * 1000;

   // Result values VOLUME
  const percentResultVolume = percentVolume * 100;
  const numberOfMenVolume   = Math.floor(numberLargerV);
  // ***** END VOLUME calculation: *******


  return (

      <div id="bedbible_penis_calculator">
        <div id="input_block">
          <form onsubmit="event.preventDefault();" className="container">

            <div className="row align-middle" id="length_block">
              <div className="col-3 col-md-3 col-lg-3">
                <h3>LENGTH</h3>
              </div>
              <div className={`col-3 col-md-3 col-lg-3 afterElement ${!isCantimeters ? 'inches' : ''}`}>
                <input type="number" name="" placeholder="0" id="lengthValue" 
                  maxlength="2"
                  onInput={(event) => handleLengthChange(event)}
                />
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                {isLength > 0 &&
                  <>
                  <span className="final-percentage">{percentResult.toFixed(2)}%</span>
                  <span className="final-percentage-text">In a room of 1000, {numberOfMen} would be bigger</span>
                  </>
                }
              </div>
            </div>

            <div className="row align-middle" id="girth_block">
              <div className="col-3">
                <h3>GIRTH</h3>
              </div>
              <div className={`col-3 afterElement ${!isCantimeters ? 'inches' : ''}`}>
                <input 
                  type="number" 
                  name="" 
                  placeholder="0" 
                  id="girthValue" 
                  maxlength="2"
                  onInput={(event) => handleGirthChange(event)} 
                />
              </div>
              <div class="col-6">
                {isGirth > 0 &&
                  <>
                  <span className="final-percentage">{percentResultGirth.toFixed(2)}%</span>
                  <span className="final-percentage-text">In a room of 1000, {numberOfMenGirth} would be bigger</span>
                  </>
                }
              </div>
            </div>

            <div className="row align-middle" id="volume_block">
              <div className="col-3">
                <h3>OVERALL</h3> 
              </div>  
              <div className={`col-4 col-sm-3 col-md-3 col-lg-3 afterElement ${!isCantimeters ? 'flOz' : ''}`}>
              {(isLength <= 0 || isGirth <= 0) &&
                <input type="number" name="" placeholder="0" disabled />
              }
              {(isLength > 0 && isGirth > 0 && isCantimeters) &&
                <input type="number" name="" value={volumeInML.toFixed(1)} disabled />
              }
              {(isLength > 0 && isGirth > 0 && !isCantimeters) &&
                <input type="number" name="" value={volumeInFlOz.toFixed(1)} disabled />
              }
              </div>
              <div className="col-5 col-sm-6 col-md-6 col-lg-6">
              {(isLength > 0 && isGirth > 0) &&
                <>
                <span className="final-percentage">{percentResultVolume.toFixed(2)}%</span>
                <span className="final-percentage-text">In a room of 1000, {numberOfMenVolume} would be bigger</span>
                </>
              }
              </div>
            </div>

            <div className="row align-middle" id="result_text">
              <div className="col-12">
                <span id="result_text_bottom">This makes you about {factorX.toFixed(2)}x the average size.</span>
              </div>
            </div>

            <div className="row text-center" id="switcher_block">
              <div className="col-12">
                <input type="radio" className="btn-check" name="options-base" id="inches" 
                  value={false}
                  checked={isCantimeters === false}
                  onChange={handleCantimetersChange}
                />
                <label className="btn" htmlFor="inches">inchces / fl oz</label>

                <input type="radio" className="btn-check" name="options-base" id="cantimeters" 
                  value={true}
                  checked={isCantimeters === true}
                  onChange={handleCantimetersChange}
                />
                <label className="btn mr-3" htmlFor="cantimeters">cm / ml</label>
              </div>
            </div>


          </form> 
        </div>
      </div>
  );
}

export default App;
